import { useLocation } from "react-router-dom";

export default function useLocationStateParam<T>(prop: string) {
    const { state } = useLocation<Record<string, T> | undefined>();

    return state ? state[prop] : undefined;
}